import { Cell, Header } from '@tanstack/react-table';

export const calcGridTemplate = (cell: Cell<unknown, unknown> | Header<unknown, unknown>) => {
  const size = cell.column.getSize();
  const widthPx = cell.column?.columnDef?.meta?.widthPx;
  return widthPx ? `${widthPx}px` : `minmax(0, ${size}fr)`;
};
